import request from "../helpers/request";
import {createRestfulApi} from "@/api/createRestfulApi";

const URL = {
    GET_EVALUATION_LIST: "evaluation/getEvaluationList",
    SAVE_EVALUATION: "evaluation/saveEvaluation",
    DELETE_EVALUATION: "evaluation/deleteEvaluation",
    GET_PROJECT_USER_LIST: "evaluation/getProjectUserList",
};

export default {
    url: URL,
    post(url, payload) {
        return request(url, "POST", payload);
    },
    getEvaluationList: createRestfulApi(URL.GET_EVALUATION_LIST, {
        queryParams: [],
    }),
};
